import { getAllTrash } from "../api/trash";
import { GET_TRASH, GET_TRASH_ERROR, GET_TRASH_SUCCESS } from "./types";

export const getTrash = () => (dispatch) => {
  dispatch({ type: GET_TRASH });

  const onSuccess = (response) => dispatch({ type: GET_TRASH_SUCCESS, payload: response });
  const onError = (error) => dispatch({ type: GET_TRASH_ERROR, payload: error });

  getAllTrash(onSuccess, onError);
};
